import React,{useState} from 'react';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import MDTextField from 'components/MDTextField';
import MDSelect from 'components/MDSelect';
import { handleValueChange } from 'api/globle';
import {email_verified} from 'Data/Data';
import useMediaQuery from 'hooks/MediaQuery';


const AllUsersModal = ({title, data, setFilteredData, buttonName1, buttonName2}) =>{
  const isDesktop = useMediaQuery('(min-width: 950px)');

  const [openModal, setOpenModal]= useState(false);
  const [isClearButton, setIsClearButton] = useState(false);
  const [searchValues, setSearchValues] = useState({
  email: '',
  emailVerification: '',
})

const handleChange = (e) => {
  const search = handleValueChange(e, searchValues );
  setSearchValues(search);
};

const filterData = () => {
  const { email, emailVerification } = searchValues;

  const filtered = data.filter(item => {
    // Define the conditions for each search value
    const emailMatch = email ? item.email === email : true;
    const emailVerificationMatch = emailVerification ? String(item.emailVerified) === emailVerification : true;
    
    // Check if all conditions are met
    return emailMatch && emailVerificationMatch;
  });

  // Only set data if any search value is provided
  if (email || emailVerification) {
      setFilteredData(filtered);
      setIsClearButton(true);
  }

};

const clearFilters = () => {
  setSearchValues({
    email: '',
    emailVerification: '',
  });
  setFilteredData(data);
  setIsClearButton(false);
};

  return (
    <div>
      <div style={{display:"flex"}}>
      <FilterAltIcon fontSize="medium" color="white" style={{ cursor:"pointer", marginRight: "10px", backgroundColor:"#fff", fill:"#14a4a4", borderRadius:"8px", fontSize:"40px"}} onClick={()=>setOpenModal(true)}/>
      {isClearButton ? <Button onClick={clearFilters} style={{backgroundColor: "#fff", color:"#14a4a4"}}>Clear Filters</Button> : null}
      </div> 
      <Dialog open={openModal} onClose={()=>setOpenModal(false)}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent >
          <div>
          <div style={{display: isDesktop ? "flex" : ""}}>
          <MDTextField name="email" label="Email" value={searchValues.email} type="email" handlerChange={handleChange}/>
          <MDSelect name="emailVerification" label="Verification" options={email_verified} value={searchValues.emailVerification} handlerChange={handleChange}/>
          </div>
        </div>

        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{setOpenModal(false);filterData()}} color="primary">
            {buttonName1}
          </Button>
          <Button onClick={()=>setOpenModal(false)} color="primary">
            {buttonName2}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}


export default AllUsersModal;
